/**
 * PREVIEW COMPANY ENTRY POINT
 *
 * The preview company page shows the available articles for a non active entity
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import PestleHelp from '../../reusable/PestleHelp/PestleHelp';
import IndexTermHelp from '../../reusable/IndexTermHelp/IndexTermHelp';
import utils from './../../utils/utilities';
import reduxStore from './../../reduxStore';
import { PREVIEW_ARTICLE_UNLICENCED_CHAR_LIMIT }from '../../constants';
import storage from "../../utils/storage";

let dateFormat = require('dateformat');

export default class PreviewArticle extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let user = reduxStore.getState().user;

        if (!this.props.articleData) {
            return (<div></div>);
        }

        //all information to be displayed if available
        let source = this.props.articleData.source ? this.props.articleData.source : null;
        let title = this.props.articleData.title ? this.props.articleData.title : null;

        let section = null;
        if (this.props.articleData.section) {
            section = (
                <div className="article-body__section ">
                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.in" />: {this.props.articleData.section}
                </div>
            )
        }

        let publishDate;
        if (this.props.articleData.publishDate) {
            try {
                publishDate = dateFormat(new Date(this.props.articleData.publishDate), "mmm dd, yyyy dddd h:MM TT Z");
            }
            catch (err) {
                publishDate = null;
                utils.logError("DateContentCell(): ", "Not a date; Value received: " + this.props.articleData.publishDate);
            }
        } else {
            publishDate = null;
        }

        let author = this.props.articleData.author ? this.props.articleData.author : null;

        let articleContent = this.props.articleData.content ? this.props.articleData.content : null;
        // licenced articles will be fully shown
        // un-licenced articles will be trimmed from 300 characters, to the first space character,
        // then ellipsis will be added
        if (!this.props.articleData.licensed) {
            articleContent = {__html: articleContent + "..."};
            // articleContent = utils.toEllipsis(articleContent, PREVIEW_ARTICLE_UNLICENCED_CHAR_LIMIT);
        } else {
            articleContent = {__html: articleContent};
        }

        let originalUrl = this.props.articleData.url ? this.props.articleData.url : '#';
        let copyright = this.props.articleData.copyright ? this.props.articleData.copyright : null;

        let matchedEntities = null;
        let found = false;
        if (this.props.articleData.matchedEntities) {

            matchedEntities = this.props.articleData.matchedEntities.map((value) => {
                found = true;
                return (
                    <div className="article-details__entity-mentioned" key={"third-party-" + value.id}>
                    <span className="entity-name">
                        {value.companyTitle}
                    </span>
                    </div>
                );
            });
        }
        if (!found) {
            matchedEntities = (<div className="article-details__no-entity-mentioned"><FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.noEntities"/></div>)
        }

        //article scores and risk levels
        let scores = this.props.articleData.scores;

        let pestleList = ['political', 'economic', 'social', 'technological', 'legal', 'environmental'];
        let pestleObj = {};

        for (let i = 0; i < pestleList.length; i++) {
            pestleObj[pestleList[i] + '-' + 'L'] = {level: 'L', angle: pestleList[i], classes: 'low'};
            pestleObj[pestleList[i] + '-' + 'M'] = {level: 'M', angle: pestleList[i], classes: 'medium'};
            pestleObj[pestleList[i] + '-' + 'H'] = {level: 'H', angle: pestleList[i], classes: 'high'};
        }

        if (scores) {
            for (let j = 0; j < scores[0].length; j++) {
                let key = scores[0][j].name + "-" + scores[0][j].scoreLevel;
                let newPguid = utils.getPguid(scores[0][j].pguid, user.preferences.language);
                if (!pestleObj[key].text) {
                    pestleObj[key].text = "";
                } else {
                    pestleObj[key].text = pestleObj[key].text = pestleObj[key].text + ', ';
                }
                pestleObj[key].text = pestleObj[key].text + newPguid;
            }
        }

        let riskAngleMatches = null;

        let riskAnglesMatches = {};
        if (pestleObj) {

            riskAngleMatches = Object.keys(pestleObj).map(function(value) {

                if (pestleObj[value].text) {

                    riskAnglesMatches[pestleObj[value].angle] = true;
                    let riskClasses = 'risk-bullet ' + pestleObj[value].classes;
                    return (

                        <div className="sectionRiskAngles__rows" key={"risk-angles-" + value}>

                            <div className="risk-angle-level">
                            <span className="risk-angle-name">
                                <FormattedMessage
                                    id={"General_CoreFunctionality_UIText_general." + pestleObj[value].angle} />
                            </span>
                                <span className={riskClasses}>
                                <FormattedMessage
                                    id={"General_CoreFunctionality_UIText_general.risk." + pestleObj[value].level} />
                            </span>
                            </div>

                            <div className="index-term-matched">
                                <span>{pestleObj[value].text}</span>
                            </div>

                        </div>
                    )

                } else {
                    return null;
                }

            });

        }

        //About article rows
        let wordCount = null;
        if (this.props.articleData.wordCount) {
            wordCount = (
                <div className="section-about__rows">
                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.length" /><b>:</b>
                    <span> {this.props.articleData.wordCount}</span> <FormattedMessage
                    id="Entities_Preview_UIText_previewCompanies.articleView.words" />
                </div>
            )
        }

        let language = null;
        if (this.props.articleData.language) {
            language = (
                <div className="section-about__rows">
                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.language" /><b>:</b> <FormattedMessage
                        id={"General_CoreFunctionality_UIText_languageSelect." + this.props.articleData.language.toLowerCase()} />
                </div>
            )
        }

        let journalCode = null;
        if (this.props.articleData.journalCode) {
            journalCode = (
                <div className="section-about__rows">
                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.journal" /><b>:</b> {this.props.articleData.journalCode}
                </div>
            )
        }

        let publicationType = null;
        if (this.props.articleData.publicationType) {
            publicationType = (
                <div className="section-about__rows">
                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.publication" /><b>:</b> {this.props.articleData.publicationType}
                </div>
            )
        }

        let loadDate = null;
        let loadDateFormatted,
            formattedDateMonth,
            formattedDateWithoutMonth,
            isDateValid = true;

        if (this.props.articleData.harvestDate) {
            try {
                loadDateFormatted = dateFormat(new Date(this.props.articleData.harvestDate), "mmm dd, yyyy h:MM TT Z");
            }
            catch (err) {
                loadDateFormatted = null;
                isDateValid = false;
                utils.logError("DateContentCell(): ", "Not a date; Value received: " + this.props.articleData.harvestDate);
            }

            if (isDateValid) {
                formattedDateMonth = loadDateFormatted.split(' ')[0];
                formattedDateWithoutMonth = loadDateFormatted.substring(loadDateFormatted.indexOf(' ') + 1);
            }

            loadDate = (
                <div className="section-about__rows">
                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.loadDate" /><b>:</b> {
                    isDateValid ?
                        <span className="date-label">
                            <FormattedMessage
                                id={"General_CoreFunctionality_UIText_date.month." +
                                formattedDateMonth } /> <span>{formattedDateWithoutMonth}</span>
                        </span>
                        :
                        <span>{loadDateFormatted}</span>
                }
                </div>
            )
        }

        return (
            <div className="preview-article-page">
                <div className="article-body">

                    <div className="article-body__source">
                        {source}
                    </div>

                    {section}

                    <div className="article-body__headline" dangerouslySetInnerHTML={{__html: title}}>
                    </div>

                    <div className="article-body__date-author">
                    <span className="article-body__date-author--publish-date">
                        {publishDate}
                    </span>

                        {author ? <span className="article-body__date-author--author">                         
                                {author}
                              </span>
                            : null}

                    </div>

                    <div className="article-body__content" dangerouslySetInnerHTML={articleContent}></div>

                    { !this.props.articleData.licensed ?

                        <div className="article-body__url">
                            <a href={originalUrl} target="_blank">
                                <FormattedMessage
                                    id="Entities_Preview_UIText_previewCompanies.articleView.viewFullArticle" />
                            </a>
                        </div>

                        : null }

                    <div className="article-body__copyright">
                        {copyright}
                    </div>

                </div>

                <div className="notranslate article-details">

                    <div className="article-details__section-third-parties">
                        <div className="section-title">
                            <FormattedMessage
                                id="Entities_Preview_UIText_previewCompanies.articleView.sectionThirdParties" />
                        </div>
                        {matchedEntities}
                    </div>

                    <div className="article-details__section-risk-angle-matches">

                        <div className="section-title">
                            <FormattedMessage
                                id="Entities_Preview_UIText_previewCompanies.articleView.sectionRiskAngles" />
                        </div>

                        <div>

                            <div className="subtitles">
                                <span className="subtitles__risk-and-level">
                                    <FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.RiskAngleLevel" /><PestleHelp position={'left'} riskAngleMatches={riskAnglesMatches}/>
                                </span>
                                <span className="subtitles__index-term">
                                    <FormattedMessage
                                        id="Entities_Preview_UIText_previewCompanies.articleView.indexTermMatched" /> <IndexTermHelp position={'left'} pguids={this.props.articleData.scores[0]} />
                                </span>
                            </div>

                            {riskAngleMatches}

                        </div>

                    </div>

                    <div className="article-details__section-about">
                        <div className="section-title">
                            <FormattedMessage
                                id="Entities_Preview_UIText_previewCompanies.articleView.sectionAboutArticle" />
                        </div>

                        {wordCount}

                        {language}

                        {publicationType}

                        {journalCode}

                        {loadDate}

                    </div>


                </div>

            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/scripts/reusable/PreviewArticle/PreviewArticle.index.jsx